import { FC } from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { FormCheckbox } from 'src/components/FormCheckbox/FormCheckbox';
import { FormDatePicker } from 'src/components/FormDatePicker/FormDatePicker';
import { supportsAuthor } from 'src/store/bookings/consts';
import { getBookingsState } from 'src/store/bookings/selectors';

export const MyBookingsFiltersFields: FC = () => {
  const { bookingObjectType } = useSelector(getBookingsState);
  const {
    input: { value: from },
  } = useField<string | undefined>('from');

  return (
    <>
      <FormDatePicker
        label='Дата начала'
        name='from'
        dataTestId='from'
        fullWidth
      />
      <FormDatePicker
        label='Дата окончания'
        name='to'
        minDate={from}
        dataTestId='to'
        fullWidth
      />
      {bookingObjectType && supportsAuthor.has(bookingObjectType) && (
        <FormCheckbox name='isAuthor' label='Показать только те, где я автор' />
      )}
    </>
  );
};
